import { createAction, props } from "@ngrx/store";
import {
  AddEJournalDetailsModel,
  DataAccordingToDaySelectedModel,
  DropDownModel,
  FetchDetailsAccordingToDaySelected,
  FetchListModel,
  FetchWeekDaysDetailsModel
} from "../model/list.model";

/******** CLEAR STATE ***********/
const CLEAR_STATE = '[my-journal] clear state';
export const ClearState = createAction(CLEAR_STATE);


const FETCH_DAILY_MEAL_AND_DRINK_TRACKER_REQUEST = '[my-journal] fetch daily meal and drink tracker request'
export const FetchDailyMealAndDrinkTrackerRequest = createAction(FETCH_DAILY_MEAL_AND_DRINK_TRACKER_REQUEST, props<{
  payload: { forUserId?: any }
}>())

const FETCH_DAILY_MEAL_AND_DRINK_TRACKER_SUCCESS = '[my-journal] fetch daily meal and drink tracker success'
export const FetchDailyMealAndDrinkTrackerSuccess = createAction(FETCH_DAILY_MEAL_AND_DRINK_TRACKER_SUCCESS, props<{
  payload: FetchListModel['response']['data']
}>())

const FETCH_DAILY_MEAL_AND_DRINK_TRACKER_FAILURE = '[my-journal] fetch daily meal and drink tracker failure'
export const FetchDailyMealAndDrinkTrackerFailure = createAction(FETCH_DAILY_MEAL_AND_DRINK_TRACKER_FAILURE)


const FETCH_PHYSICAL_ACTIVITY_REQUEST = '[my-journal] fetch daily physical activity request'
export const FetchPhysicalDailyActivityRequest = createAction(FETCH_PHYSICAL_ACTIVITY_REQUEST)

const FETCH_PHYSICAL_ACTIVITY_SUCCESS = '[my-journal] fetch daily physical activity success'
export const FetchPhysicalDailyActivitySuccess = createAction(FETCH_PHYSICAL_ACTIVITY_SUCCESS, props<{
  payload: FetchListModel['response']['data']
}>())

const FETCH_PHYSICAL_ACTIVITY_FAILURE = '[my-journal] fetch daily physical activity failure'
export const FetchPhysicalDailyActivityFailure = createAction(FETCH_PHYSICAL_ACTIVITY_FAILURE)


const FETCH_DAILY_SCREEN_ACTIVITY_REQUEST = '[my-journal] fetch daily screen activity request'
export const FetchDailyScreenActivityRequest = createAction(FETCH_DAILY_SCREEN_ACTIVITY_REQUEST)

const FETCH_DAILY_SCREEN_ACTIVITY_SUCCESS = '[my-journal] fetch daily screen activity success'
export const FetchDailyScreenActivitySuccess = createAction(FETCH_DAILY_SCREEN_ACTIVITY_SUCCESS, props<{
  payload: FetchListModel['response']['data']
}>())

const FETCH_DAILY_SCREEN_ACTIVITY_FAILURE = '[my-journal] fetch daily screen activity failure'
export const FetchDailyScreenActivityFailure = createAction(FETCH_DAILY_SCREEN_ACTIVITY_FAILURE)


const FETCH_SEARCHED_DAILY_MEAL_AND_DRINK_TRACKER_LIST_REQUEST = '[my-journal] fetch searched daily meal and drink tracker list request'
export const FetchSearchedDailyMealAndDrinkTrackerListRequest = createAction(FETCH_SEARCHED_DAILY_MEAL_AND_DRINK_TRACKER_LIST_REQUEST,
  props<{ payload: { pageNumber: number, searchText: string } }>())

const FETCH_SEARCHED_DAILY_MEAL_AND_DRINK_TRACKER_LIST_SUCCESS = '[my-journal] fetch searched daily meal and drink tracker list success'
export const FetchSearchedDailyMealAndDrinkTrackerListSuccess = createAction(FETCH_SEARCHED_DAILY_MEAL_AND_DRINK_TRACKER_LIST_SUCCESS, props<{
  payload: FetchListModel['response']['data']
}>())

const FETCH_SEARCHED_DAILY_MEAL_AND_DRINK_TRACKER_LIST_FAILURE = '[my-journal] fetch searched daily meal and drink tracker list failure'
export const FetchSearchedDailyMealAndDrinkTrackerListFailure = createAction(FETCH_SEARCHED_DAILY_MEAL_AND_DRINK_TRACKER_LIST_FAILURE)


const FETCH_SEARCHED_PHYSICAL_ACTIVITY_REQUEST = '[my-journal] fetch searched daily physical activity request'
export const FetchSearchedPhysicalDailyActivityRequest = createAction(FETCH_SEARCHED_PHYSICAL_ACTIVITY_REQUEST, props<{
  payload: {
    pageNumber: number,
    searchText: string
  }
}>())

const FETCH_SEARCHED_PHYSICAL_ACTIVITY_SUCCESS = '[my-journal] fetch searched daily physical activity success'
export const FetchSearchedPhysicalDailyActivitySuccess = createAction(FETCH_SEARCHED_PHYSICAL_ACTIVITY_SUCCESS, props<{
  payload: FetchListModel['response']['data']
}>())

const FETCH_SEARCHED_PHYSICAL_ACTIVITY_FAILURE = '[my-journal] fetch searched daily physical activity failure'
export const FetchSearchedPhysicalDailyActivityFailure = createAction(FETCH_SEARCHED_PHYSICAL_ACTIVITY_FAILURE)

/******** FETCH DAYS***********/

const FETCH_WEEK_DAYS_DETAILS_REQUEST = '[my-journal] fetch week days  request'
export const FetchWeekDaysDetailsRequest = createAction(FETCH_WEEK_DAYS_DETAILS_REQUEST, props<{
  payload: FetchWeekDaysDetailsModel['request']
}>())

const FETCH_WEEK_DAYS_DETAILS_SUCCESS = '[my-journal] fetch week days request success'
export const FetchWeekDaysDetailsSuccess = createAction(FETCH_WEEK_DAYS_DETAILS_SUCCESS, props<{
  payload: FetchWeekDaysDetailsModel['response']['data']
}>())

const FETCH_WEEK_DAYS_DETAILS_FAILURE = '[my-journal] fetch week days request failure'
export const FetchWeekDaysDetailsFailure = createAction(FETCH_WEEK_DAYS_DETAILS_FAILURE)


/******** FETCH DATA ACCORDING TO DAYS ***********/
const FETCH_DATA_ACCORDING_TO_DAY_SELECTED_REQUEST = '[my-journal] fetch data according to day selected request'
export const FetchDataAccordingToDaySelectedRequest = createAction(FETCH_DATA_ACCORDING_TO_DAY_SELECTED_REQUEST, props<{
  payload: DataAccordingToDaySelectedModel['request']
}>())

const FETCH_DATA_ACCORDING_TO_DAY_SELECTED_SUCCESS = '[my-journal] fetch data according to day selected success'
export const FetchDataAccordingToDaySelectedSuccess = createAction(FETCH_DATA_ACCORDING_TO_DAY_SELECTED_SUCCESS, props<{
  payload: FetchDetailsAccordingToDaySelected
}>())

const FETCH_DATA_ACCORDING_TO_DAY_SELECTED_FAILURE = '[my-journal] fetch data according to day selected failure'
export const FetchDataAccordingToDaySelectedFailure = createAction(FETCH_DATA_ACCORDING_TO_DAY_SELECTED_FAILURE)


/******** FETCH Meal Type ***********/
const FETCH_MEAL_TYPE_REQUEST = '[my-journal] fetch meal type request'
export const FetchMealTypeRequest = createAction(FETCH_MEAL_TYPE_REQUEST);

const FETCH_MEAL_TYPE_SUCCESS = '[my-journal] fetch meal type success';
export const FetchMealTypeSuccess = createAction(FETCH_MEAL_TYPE_SUCCESS, props<{
  payload: DropDownModel['response']['data']
}>());

const FETCH_MEAL_TYPE_FAILURE = '[my-journal] fetch meal type failure';
export const FetchMealTypeFailure = createAction(FETCH_MEAL_TYPE_FAILURE);

/******** FETCH TOD Type ***********/
const FETCH_TOD_TYPE_REQUEST = '[my-journal] fetch tod type request'
export const FetchTodTypeRequest = createAction(FETCH_TOD_TYPE_REQUEST);

const FETCH_TOD_TYPE_SUCCESS = '[my-journal] fetch tod type success';
export const FetchTodTypeSuccess = createAction(FETCH_TOD_TYPE_SUCCESS, props<{
  payload: DropDownModel['response']['data']
}>());

const FETCH_TOD_TYPE_FAILURE = '[my-journal] fetch tod type failure';
export const FetchTodTypeFailure = createAction(FETCH_TOD_TYPE_FAILURE);

/******** Add Daily Meal ***********/
const ADD_E_JOURNAL_REQUEST = '[my-journal] add e journal request';
export const AddEJournalRequest = createAction(ADD_E_JOURNAL_REQUEST, props<{
  payload: AddEJournalDetailsModel['request']
}>())

const ADD_E_JOURNAL_SUCCESS = '[my-journal] add e journal success';
export const AddEJournalSuccess = createAction(ADD_E_JOURNAL_SUCCESS, props<{
  payload: {
    forUserId?: any;
    date: any;
  }
}>())

const ADD_E_JOURNAL_FAILURE = '[my-journal] add e journal failure';
export const AddEJournalFailure = createAction(ADD_E_JOURNAL_FAILURE)

/* fetch light type  */
const FETCH_COLOR_TYPE_REQUEST = '[my-journal] fetch color type request'
export const FetchColorTypeRequest = createAction(FETCH_COLOR_TYPE_REQUEST);

const FETCH_COLOR_TYPE_SUCCESS = '[my-journal] fetch color type success';
export const FetchColorTypeSuccess = createAction(FETCH_COLOR_TYPE_SUCCESS, props<{
  payload: DropDownModel['response']['data']
}>());

const FETCH_COLOR_TYPE_FAILURE = '[my-journal] fetch color type failure';
export const FetchColorTypeFailure = createAction(FETCH_COLOR_TYPE_FAILURE);

/******** DELETE RECORD ***********/
const DELETE_MY_JOURNAL_RECORD_REQUEST = '[my journal] delete my journal record request';
export const DeleteMyJOurnalRecordsRequest = createAction(DELETE_MY_JOURNAL_RECORD_REQUEST, props<{
  payload: { recordType?: any, recordId?: any, selectedDate?: any, memberId?: any }
}>())

const DELETE_MY_JOURNAL_RECORD_SUCCESS = '[my journal] delete my journal record success';
export const DeleteMyJOurnalRecordsSuccess = createAction(DELETE_MY_JOURNAL_RECORD_SUCCESS, props<{
  payload: { selectedDate?: any, memberId?: any }
}>())

const DELETE_MY_JOURNAL_RECORD_FAILURE = '[my journal] delete my journal record failure';
export const DeleteMyJOurnalRecordsFailure = createAction(DELETE_MY_JOURNAL_RECORD_FAILURE,);

/******** Edit Records  ***********/
const EDIT_RECORDS_REQUEST = '[my journal] edit records request'
export const EditRecordsRequest = createAction(EDIT_RECORDS_REQUEST, props<{
  payload: {
    params: { recordType: any, recordId: any },
    data: any
    memberId?: any,
    date?: any
  }
}>())

const EDIT_RECORDS_SUCCESS = '[my journal] edit records success'
export const EditRecordsSuccess = createAction(EDIT_RECORDS_SUCCESS)

const EDIT_RECORDS_FAILURE = '[my journal] edit records failure'
export const EditRecordsFailure = createAction(EDIT_RECORDS_FAILURE)

/******** CLEAR SEARCHED FOOD STATE ***********/
const CLEAR_SEARCHED_FOOD_LIST = '[my-journal] clear searched food list'
export const ClearSearchedFoodList = createAction(CLEAR_SEARCHED_FOOD_LIST)


/******** CLEAR SEARCHED PHYSICAL ACTIVITY STATE ***********/
const CLEAR_SEARCHED_PHYSICAL_ACTIVITY_LIST = '[my-journal] clear searched physical activity list'
export const ClearSearchedPhysicalActivityList = createAction(CLEAR_SEARCHED_FOOD_LIST)

/******** FETCH_SCREEN_TYPE ***********/
const FETCH_SCREEN_TYPE_REQUEST = '[my-journal] fetch screen type request'
export const FetchScreenTypeRequest = createAction(FETCH_SCREEN_TYPE_REQUEST);

const FETCH_SCREEN_TYPE_SUCCESS = '[my-journal] fetch screen type success';
export const FetchScreenTypeSuccess = createAction(FETCH_SCREEN_TYPE_SUCCESS, props<{
  payload: DropDownModel['response']['data']
}>());

const FETCH_SCREEN_TYPE_FAILURE = '[my-journal] fetch screen type failure';
export const FetchScreenTypeFailure = createAction(FETCH_SCREEN_TYPE_FAILURE);

/******** FETCH_ACTIVITY_TYPE ***********/
const FETCH_ACTIVITY_TYPE_REQUEST = '[my-journal] fetch activity type request'
export const FetchActivityTypeRequest = createAction(FETCH_ACTIVITY_TYPE_REQUEST);

const FETCH_ACTIVITY_TYPE_SUCCESS = '[my-journal] fetch activity type success';
export const FetchActivityTypeSuccess = createAction(FETCH_ACTIVITY_TYPE_SUCCESS, props<{
  payload: DropDownModel['response']['data']
}>());

const FETCH_ACTIVITY_TYPE_FAILURE = '[my-journal] fetch activity type failure';
export const FetchActivityTypeFailure = createAction(FETCH_ACTIVITY_TYPE_FAILURE);
